export class LockBeaconModel {
    deviceId: string;
    doorId?: string;
    /** True when the company has more than 254 beacon/lock devices, i.e. the door ID pool has wrapped */
    doorIdRotationActive?: boolean;
    /** True when this device's door ID is also assigned to another beacon/lock in the same company */
    doorIdShared?: boolean;
    /** The other devices in the company carrying the same door ID (empty when unique) */
    doorIdSharedDevices?: SharedDoorIdDevice[];
    name: string;
    deviceType: string;
    alertWhenButtonInLockArea: boolean;
    openDoorForUnknownButton: boolean;
    closeDoorForUnknownButton: boolean;
    allowedDevices: LockBeaconDevice[];
    deniedDevices: LockBeaconDevice[];
    lostDevicesUpdated: boolean;
}

/** A beacon/lock that shares its door ID with another device in the same company */
export class SharedDoorIdDevice {
    deviceId: string;
    name: string;
    /** Location the device belongs to, so it can be checked whether the two are physically close */
    locationName: string;
}

export class LockBeaconDevice {
    id: string;
    name: string;
    deviceType: string;
    lostDevice: boolean;
    validityTimes: LockBeaconValidityTimes[];
    editMode: boolean; //UI ONLY
}

export class LockBeaconValidityTimes {
    weekDaysFrom: string = "00:00";
    weekDaysTo: string = "23:59";
    saturdaysFrom: string = "00:00";
    saturdaysTo: string = "23:59";
    sundaysFrom: string = "00:00";
    sundaysTo: string = "23:59";
}